import { render } from "./PatientAppointmentPage.vue?vue&type=template&id=633e016a&scoped=true"
import script from "./PatientAppointmentPage.vue?vue&type=script&lang=js"
export * from "./PatientAppointmentPage.vue?vue&type=script&lang=js"

import "./PatientAppointmentPage.vue?vue&type=style&index=0&id=633e016a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633e016a"]])

export default __exports__